import React, { PropTypes } from 'react';
import Pagination from '../Common/Pagination';
import AccessItem from './AccessItem';
import RemoveAccents from 'remove-accents';

export default class AccessLog extends React.Component {

	constructor(props) {
		super(props);
		this.state = { isFetching: false, message: "", status: "", order: "asc",
			orderUsername: "asc", whichOrder: "id" };
	}
	componentWillMount() {
		this.props.actions.getAccessLogList();
	}

	filterByPage(array, itemsPerPage, page) {
		const endIndex = itemsPerPage * page - 1;
		const startIndex = endIndex - itemsPerPage + 1;
		return array.slice(startIndex, endIndex + 1);
	}

	getTotalPages() {
		const { itemsPerPage } = this.props.pagination;
		return Math.ceil(this.filterByState().length / itemsPerPage);
	}

	getTotalLogs() {
		return this.filterByState().length;
	}

	getLogs() {
		const { itemsPerPage, currentPage } = this.props.pagination;
		const finalList = this.sortByState(this.filterByState());
		const slice = this.filterByPage(finalList, itemsPerPage, currentPage); 
		return slice;
	}

	compareNumberToTerms(number, terms) {
		var outputID = false;
		terms.forEach((term) => {
			if (outputID === true) return;
			if (number.toString() === term) {
				outputID = true;
				return true;
			} else { return false; }
		});
		return outputID;
	}

	filterBySearchTerms(list) {
		const terms = this.props.filter.selectedTerms;
		if ( terms.length === 0 ) return list;

		return list.filter((log) => {
			
			const nome = RemoveAccents.remove(log.nome.toLowerCase().normalize());
			const username = RemoveAccents.remove(log.username.toLowerCase().normalize());
			
			if (this.compareNumberToTerms(log.id, terms)) {
				return true;
			}

			if (new RegExp(terms.join("|")).test(nome)) {
				return true;
			}

			if (new RegExp(terms.join("|")).test(username)) {
				return true;
			}
			return false;
		});
	}

	filterByState() {
		const list = this.props.access_log;
		// return list;
		return this.filterBySearchTerms(list);
		// if (this.state.whichOrder === "nome") {
		// 	return this.filterBySearchTerms(this.sortName(list));
		// } else if (this.state.whichOrder === "username") {
		// 	return this.filterBySearchTerms(this.sortUsername(list));
		// }
	}

	sortById(a, b) {
		return a.id - b.id;
	}

	sortByName(a, b) {
		var nameA = a.nome.toLowerCase(); 
		var nameB = b.nome.toLowerCase();
		if (nameA < nameB) { return -1; }; //sort string ascending 
		if (nameA > nameB) { return 1; };
		return 0; //default return value (no sorting)
	}

	sortByUsername(a, b) {
		try {
			var nameA = a.username.toLowerCase(); 
			var nameB = b.username.toLowerCase();
			if (nameA < nameB) { return -1; }; //sort string ascending 
			if (nameA > nameB) { return 1; };
			return 0; //default return value (no sorting)
		} catch (error) {
			return -1;
		}
	}

	sortByDate(a, b) {
		var dateA = new Date(a.retiredate);
		var dateB = new Date(b.retiredate);
		return dateA - dateB; //sort by date ascending
	}

	sortByState(list) {
		const { whichOrder, order } = this.state;
		let sortedList = list;
		switch (whichOrder) {

			case "id":
				sortedList = order === "asc" 
				? list.reverse(this.sortById) : list.sort(this.sortById);
				return sortedList;

			case "nome":
				sortedList = order === "asc" 
				? list.reverse(this.sortByName) : list.sort(this.sortByName);
				return sortedList;

			case "data":
				sortedList = order === "asc" 
				? list.reverse(this.sortByDate) : list.sort(this.sortByDate);
				return sortedList;

			case "username":
				sortedList = order === "asc" 
				? list.reverse(this.sortByUsername) : list.sort(this.sortByUsername);
				return sortedList;
		}
	}

	renderLogs() {
		// let listaUsuarios = this.props.users.users;
		return ( 
			<div>
				{this.getLogs().map((access, i) =>
					<AccessItem							
						index={i}
						key={access.id}
						id={access.id}
						timestamp={access.date}
						email={access.email}
						nome={access.nome}
						username={access.username}			
					/>
				)}
			</div>
		);
	}
	render () {
		return (
			<div className="container">
				<div>
					<h2 className="text-center">Histórico de Acesso</h2>	
				</div>
				<br></br>
				<div>
					<div>
						<form onSubmit={(e) => {
							e.preventDefault();
							e.stopPropagation();
							const tokens = this._filter.value.split(" ");
							const terms = [];
							tokens.map((t) => { 
								const parsed = RemoveAccents.remove(t.trim().normalize().toLowerCase());
								if ( parsed !== "" ) terms.push(parsed);
							});
							if ( terms.length > 0 ) {
								this.props.actions.setAccessSearchTerms(terms);
							} else {
								this.props.actions.setAccessSearchTerms([]);
							} 
						}}>
							<input
								type="text" 
								style={{width: "50%", minWidth: "200px", maxWidth: "300px"}}
								className="fas form-control" 
								placeholder="&#xf002; " 
								ref={(node) => this._filter = node}
								onChange={(e) => {
									if ( e.target.value === "" ) {			
										this.props.actions.setAccessSearchTerms([]);
									}
								}}							
							/>
						</form>

					</div>
				</div>
				<br></br>
				<div>
					<div className="accesslog-headerManageUsers accesslog-container">
						<div className="accesslog-categoria accesslog-row" style={{maxWidth: "40px"}} >
							<div className="accesslog-row-item">
								<div>
									{(this.state.order === "asc") 
									? <button className="accesslog-OrderButton" 
												style={this.state.whichOrder !== "id" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "desc", whichOrder: "id" })}>&#xf161;</button>
									:	<button className="accesslog-OrderButton" 
												style={this.state.whichOrder !== "id" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "asc", whichOrder: "id" })}>&#xf884;</button>
									} 
									ID
								</div>
							</div>
						</div>
						<div className="accesslog-categoria accesslog-row">
							<div className="accesslog-row-item">
								<div>
									{(this.state.order === "asc") 
									? <button className="accesslog-OrderButton" 
												style={this.state.whichOrder !== "nome" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "desc", whichOrder: "nome" })}>&#xf161;</button>
									:	<button className="accesslog-OrderButton" 
												style={this.state.whichOrder !== "nome" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "asc", whichOrder: "nome" })}>&#xf884;</button>
									} 
									Nome
								</div>
							</div>
						</div>
						<div className="accesslog-categoria accesslog-row">
							<div className="accesslog-row-item">
								<div>
									{(this.state.order === "asc") 
									? <button className="accesslog-OrderButton"
												style={this.state.whichOrder !== "data" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "desc", whichOrder: "data" })}>&#xf161;</button>
									:	<button className="accesslog-OrderButton"
												style={this.state.whichOrder !== "data" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "asc", whichOrder: "data" })}>&#xf884;</button>
									} 
									Data
								</div>
							</div>
						</div>
						<div className="accesslog-categoria accesslog-row">
							<div className="accesslog-row-item">
								<div>
									{(this.state.order === "asc") 
									? <button className="accesslog-OrderButton"
												style={this.state.whichOrder !== "username" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "desc", whichOrder: "username" })}>&#xf161;</button>
									:	<button className="accesslog-OrderButton"
												style={this.state.whichOrder !== "username" ? {color: "gray"} : {color: "blue"}}
									onClick={(n) => this.setState({ order: "asc", whichOrder: "username" })}>&#xf884;</button>
									} 
									username
								</div>
							</div>
						</div>
						{/* <div className="accesslog-categoria accesslog-row">
							<div className="accesslog-row-item">
								Detalhes
							</div>
						</div> */}
					</div>		
					<br></br>	
					{this.renderLogs()}
				</div>
				<div>
					<Pagination 
					pagination={this.props.pagination} 
					setPage={this.props.actions.setAccessCurrentPage}
					totalPages={this.getTotalPages()}
					totalDocuments={this.getTotalLogs()}
					paginationName="Acessos"
					/>
				</div>
			</div>
		);
	}
}

AccessLog.propTypes = {
	isFetching: PropTypes.bool.isRequired,
	access_log: PropTypes.object.isRequired,
	pagination: PropTypes.object.isRequired,
	filter: PropTypes.object.isRequired,
	actions: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/ManageUser/AccessLog.js